import { Loading } from '../../components/common'
import { DOMComment } from '../../shared/utils'
import styles from './DefaultLayout.module.scss'
import useDefaultLayout from './useDefaultLayout'

interface DefaultLayoutProps {
  children?: React.ReactNode
}

const DefaultLayout = (props: DefaultLayoutProps) => {
  const { children } = props
  const { loading } = useDefaultLayout()

  return (
    <div className={styles.defaultLayoutRoot}>
      <Loading
        loading={loading}
        message="Loading defaultLayout(detected zones)..."
      >
        <header>
          <DOMComment text="Obsession Click" />
        </header>
        <main>{children}</main>
        <footer>
          <DOMComment text="Nothing to see here. Dust under the rug." />
        </footer>
      </Loading>
    </div>
  )
}

export default DefaultLayout
